<template>
  <div v-if="isLoading || fetchingProfile">
    <v-skeleton-loader type="text" width="100" class="mb-4" />
    <v-skeleton-loader type="text@3" width="200" />
  </div>
  <div v-else>
    <p class="subtitle-2 ma-0 pa-0 px-2 mb-4" style="font-weight: 700">
      {{ $t('common.team_other') }}
    </p>
    <v-list nav dense class="ma-0 pa-0" v-if="availableTeams.length">
      <v-list-item-group dense v-model="selectedTeam" class="ma-0 pa-0">
        <v-list-item
          v-for="team in availableTeams"
          class="ma-0 pa-0 px-2"
          dense
          :value="team"
          :key="team.id"
          @click="handleTeamClick(team)"
          ><v-list-item-icon class="me-4">
            <v-icon size="24" color="blue-grey"
              >mdi-account-group-outline
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              class="body-2 font-weight-regular"
              v-text="team.name"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-sheet v-else outlined rounded class="pa-4 mx-2 d-flex align-center">
      <v-icon size="24" color="blue-grey lighten-1" class="me-3"
        >mdi-beehive-outline</v-icon
      >
      <p class="body-2 ma-0 pa-0  blue-grey--text text--darken-1">
        {{ $t('profile.teams_empty_state') }}
      </p>
    </v-sheet>
    <TeamDetailDialog
      :showDialog="showDialog"
      :team="selectedTeam"
      :profileAccountId="profileAccountId"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import api from '@/api'
import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import TeamDetailDialog from './TeamDetailDialog.vue'

export default {
  name: 'Teams',

  mixins: [mixin, trackerMixin],

  components: {
    TeamDetailDialog,
  },

  props: {
    profileAccount: {
      type: Object,
      required: true,
    },
    fetchingProfile: {
      type: Boolean,
    },
  },

  data() {
    return {
      availableTeams: [],
      selectedTeam: {},
      showDialog: false,
      isLoading: false,
    }
  },

  computed: {
    profileAccountId() {
      return this.profileAccount?._id ?? ''
    },
    organizationId() {
      return this.profileAccount?.organization?._id ?? ''
    },
  },

  watch: {
    profileAccount: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal?.organization?._id) return
        if (newVal !== oldVal) this.fetchAvailableTeams()
      },
    },
  },

  methods: {
    closeDialog() {
      this.showDialog = false
      this.selectedTeam = {}
    },

    async fetchAvailableTeams() {
      try {
        this.isLoading = true
        const response = await api.teams.getTeams(this.organizationId, {
          filters: {
            member: this.profileAccountId,
          },
          options: {
            sort: {
              by: 'isLeader',
              order: 'desc',
            },
          },
        })

        this.availableTeams = response.data.results
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
      }
    },

    handleTeamClick(team) {
      this.selectedTeam = team
      this.trackProfileNavigate({ element: 'team', section: 'summary' })
      this.showDialog = true
    },
  },
}
</script>
